/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { pipe } from 'ramda';
import dec from 'ramda/src/dec';

const ONE_SECOND_IN_MILLISECONDS = 1000;

type UseTimer = {
  isActive: boolean;
  getMinutes: () => string;
  getSeconds: () => string;
  start: () => void;
  stop: () => void;
};

const useTimer = (totalTime: number): UseTimer => {
  const timer = React.useRef<NodeJS.Timeout | null>(null);
  const [seconds, setSeconds] = React.useState<number>(totalTime);
  const [isActive, setIsActive] = React.useState<boolean>(true);

  const getMinutes = (): string => String(Math.trunc(seconds / 60));
  const getSeconds = (): string => String(seconds % 60).padStart(2, '0');

  const start = (): void => {
    setIsActive(true);
  };

  const stop = (currentValue = 0): number => {
    if (currentValue) {
      return currentValue;
    }

    setIsActive(false);
    clearInterval(timer.current as NodeJS.Timeout);

    return totalTime;
  };

  const resetSecondsWhenZero = pipe(dec, stop);

  React.useEffect(() => {
    if (isActive) {
      timer.current = setInterval(() => {
        setSeconds(resetSecondsWhenZero);
      }, ONE_SECOND_IN_MILLISECONDS);
    }
  }, [isActive]);

  React.useEffect((): (() => void) => {
    return (): void => {
      stop();
    };
  }, []);

  return { isActive, getMinutes, getSeconds, start, stop };
};

export { useTimer };
